export const ValidationMessages = {
  required: "This field is required.",
  requiredSelection: "Please make a selection.",
  email: "Please enter a valid email address.",
  pattern: "Invalid format.",
  minLength: (min: number) => `Minimum length is ${min} characters.`,
  maxLength: (max: number) => `Maximum length is ${max} characters.`,
  minValue: (min: number) => `Value must be at least ${min}.`,
  maxValue: (max: number) => `Value must be no more than ${max}.`,
  match: "Values do not match.",
  fileRequired: "Please select a file.",
  checkboxRequired: "You must check this box to continue.",
} as const;
